import { Modal as BaseModal, Wizard } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useBranchCostCenters from '@ubeya/shared/hooks/account/useBranchCostCenters';
import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import ConfigureColumns from './ConfigureColumns';
import UploadCostCentersFile from './UploadCostCentersFile';

const Modal = styled(BaseModal)`
  width: 70vw;
  height: 70vh;
  max-height: 1000px;

  > .content {
    > form {
      overflow: hidden;

      > div {
        overflow: auto;
      }
    }
  }
`;

const formatCostCenter = ({ payload, columns }) =>
  Object.entries(payload).reduce((prev, [, value], index) => {
    const selectedKey = columns?.[index];
    if (!selectedKey || !value) {
      return prev;
    }

    prev[selectedKey] = value;
    return prev;
  }, {});

const ImportCostCenters = ({ onClose }) => {
  const { t } = useContext(ConfigContext);
  const { addBulkCostCenters } = useBranchCostCenters();

  const initialValues = useMemo(() => ({}), []);

  const handleSubmit = useCallback(
    async (values) => {
      const costCenters = values.file.map((payload) => formatCostCenter({ columns: values.columns, payload }));

      try {
        await addBulkCostCenters({ costCenters });
        onClose();
      } catch (err) {
        // Error is already handled in the hook via addResponseError
      }
    },
    [addBulkCostCenters, onClose]
  );

  return (
    <Modal
      onClose={onClose}
      showConfirmButton={false}
      isPaddingContent={false}
      title={t('importCostCenters') || 'Import Cost Centers'}
      closeOnClickOutside={false}>
      <Wizard initialValues={initialValues} onSubmit={handleSubmit}>
        <Wizard.Page>
          <UploadCostCentersFile />
        </Wizard.Page>

        <Wizard.Page>
          <ConfigureColumns />
        </Wizard.Page>
      </Wizard>
    </Modal>
  );
};

export default ImportCostCenters;
